import { redirect } from 'react-router';

import type { InvoiceTemplate } from '~/api/invoiceTemplates/types';
import type { Params } from '~/providers/RouterProvider/router.types';

import { HttpNotFoundError } from '~/api/errors';
import { invoiceTemplateQueryOptions } from '~/api/invoiceTemplates';
import { queryClient } from '~/providers/QueryClientProvider/queryClient';
import { routes } from '~/providers/RouterProvider/router.routes';

export const loader = async ({ params }: { params: Params<typeof routes.editInvoiceTemplate> }): Promise<InvoiceTemplate> => {
  const invoiceTemplateId = Number(params.invoiceTemplateId);

  try {
    return await queryClient.query({ ...invoiceTemplateQueryOptions(invoiceTemplateId), staleTime: 'static' });
  } catch (error) {
    if (error instanceof HttpNotFoundError) {
      throw redirect(routes.invoiceTemplates);
    }

    throw error;
  }
};
